import React from "react";

import {
	DateInput,
	Edit,
	NumberInput,
	ReferenceInput,
	required,
	SelectInput,
	SimpleForm,
	TextInput,
} from "react-admin";

const FundraisersCampaignEdit = (props) => (
	<Edit {...props} mutationMode="pessimistic">
		<SimpleForm>
			<ReferenceInput source="campaign_id" reference="campaign">
				<SelectInput label="Campagne" validate={required()} disabled optionText="abstract_title" />
			</ReferenceInput>
			<TextInput fullWidth multiline source="description" label="Titre" validate={required()} />
			<DateInput disabled source="end_date" label="Date de fin" validate={required()} />
			<NumberInput source="amount" label="Objectif de collecte" validate={required()} />
		</SimpleForm>
	</Edit>
);

export default FundraisersCampaignEdit;
